module.exports = __webpack_public_path__ + "static/img/newstop.b5c62bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newspic/newstop.jpg
// module id = WGOu
// module chunks = 51